import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { I18nService, Language } from '../../../core/services/i18n.service';

@Component({
  selector: 'app-language-switcher',
  imports: [MatButtonToggleModule],
  template: `
    <mat-button-toggle-group
      [value]="i18n.currentLang()"
      (change)="i18n.setLanguage($event.value)"
      [attr.aria-label]="i18n.translations().langSwitcher.ariaLabel"
      hideSingleSelectionIndicator
      class="lang-switcher"
    >
      <mat-button-toggle value="pt" aria-label="Português">
        {{ i18n.translations().langSwitcher.pt }}
      </mat-button-toggle>
      <mat-button-toggle value="en" aria-label="English">
        {{ i18n.translations().langSwitcher.en }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  `,
  styles: `
    .lang-switcher {
      --mat-button-toggle-height: 32px;
      --mat-button-toggle-background-color: transparent;
      --mat-button-toggle-selected-state-background-color: rgba(255, 255, 255, 0.25);
      --mat-button-toggle-text-color: rgba(255, 255, 255, 0.8);
      --mat-button-toggle-selected-state-text-color: #ffffff;
      --mat-button-toggle-divider-color: rgba(255, 255, 255, 0.4);
      --mat-button-toggle-shape: 999px;
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 600;
      letter-spacing: 0.04em;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcher {
  readonly i18n = inject(I18nService);

  setLang(lang: Language): void {
    this.i18n.setLanguage(lang);
  }
}
